import { fetchListingCollections } from '../../ducks/listingCollections.duck';
import { COLLECTION_SOURCES } from '../../util/listingCollections';
import { cantonBySlug, REGION_FIELD_KEY } from '../../util/regions';

// How many supplier cards a canton page shows: enough to show the canton has
// depth without turning the page into an unbounded listing dump.
const CARD_LIMIT = 12;

/**
 * The collection id and query for one canton, or null when the slug is unknown
 * or the Region field is not searchable.
 *
 * The indexForSearch guard is carried over from the server-side injection this
 * replaces, and it matters: pub_Region is only a queryable param once the toggle
 * is on in Console. The dangerous failure is the silent one - an API that
 * ignores an unrecognised filter returns the SAME unfiltered listings for every
 * canton, so all 26 pages would claim identical suppliers. Wrong content is
 * worse than none, so an unindexed field yields no collection at all.
 *
 * @param {string} slug canton slug
 * @param {Object} config marketplace config
 * @returns {Object|null} collection descriptor
 */
export const regionCollection = (slug, config) => {
  const canton = cantonBySlug(slug);
  if (!canton) {
    return null;
  }

  const field = (config?.listing?.listingFields || []).find(f => f.key === REGION_FIELD_KEY);
  const filterConfig = field?.filterConfig;
  if (!filterConfig?.indexForSearch) {
    return null;
  }

  const searchMode = filterConfig.searchMode === 'has_any' ? 'has_any' : 'has_all';

  return {
    id: `region-${slug}`,
    source: COLLECTION_SOURCES.QUERY,
    params: { [`pub_${REGION_FIELD_KEY}`]: `${searchMode}:${canton.option}` },
    limit: CARD_LIMIT,
  };
};

export const loadData = (params, search, config) => dispatch => {
  const collection = regionCollection(params.slug, config);
  if (!collection) {
    return Promise.resolve();
  }
  // Fetched here rather than in the component so the cards are server-rendered
  // and ship as crawlable links in the HTML.
  return dispatch(fetchListingCollections([collection], { config }));
};
